import image from "src/assets/images/matchingIcon.png"

export const matchingIcon = image
